import React from 'react';

import { NumericRowData } from '../../../../interfaces/numericList.types';

import { Container, NumberItem, Row, Value } from './numericList.styled';
import { NumericListComponentData } from './numericList.types';

export const NumericList: React.FC<NumericListComponentData> = (data: NumericListComponentData) => {
  const { rows } = data;

  const renderRows = () => rows.map((row: NumericRowData, index: number) => (
    <Row key={row.value}>
      <NumberItem>{index + 1}.</NumberItem>
      <Value>{row.value}</Value>
    </Row>
  ));

  return (
    <Container className='numeric-list'>
      {renderRows()}
    </Container>
  );
}
